import { NgModule } from '@angular/core';
import { StepperComponent } from "./shared/stepper/stepper/stepper.component";
import { StepperContainerComponent } from './shared/stepper/stepper-container/stepper-container.component';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    StepperContainerComponent,
    StepperComponent
  ],
  exports: [
    StepperContainerComponent,
    StepperComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
  ],
})
export class SharedModule { }
